import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';
class HtmlWithLink extends Component {
  
  componentDidMount(){
      // console.log(this.props);
  }
  render () {
    const {colData,id,header} = this.props;
    const eventsHandler = {
      onClick:() => (colData.clickHandler) ?
              colData.clickHandler(colData,colData.attributes):
                    'javascript(void)'
    }
    const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
    // console.log(colData);
    const href = (colData.href) ? colData.href:"#";
      return(
          <td key={"column"+this.props.id}>
            {(access_mode==true)? 
              <LinkContainer key={id} to={href}>
              <a {...eventsHandler} {...header.attributes} {...colData.attributes} >
                {colData.value}
              </a>
              </LinkContainer>
            :''}
            
          </td>
      );
  }
}

export default HtmlWithLink;